<template>
	<b-modal
		ref="specimen-dead-details-modal"
		size="lg"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bolder">Detalle de Motivo: {{ reason.name }}</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="row.specimen" show_details_icon />
							</b-td>
							<b-td class="text-center text-danger font-weight-bolder">
								{{ row.is_depuration_reason ? "DEPURADO" : "MUERTO" }}
							</b-td>
							<b-td class="text-center">
								{{ row.date_dead | myGlobalDayShort }}
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import DeadsService from "@/services/deads.service.js"
export default {
	name: "SpecimenDeadDetails",
	props: {
		year: Object,
		gender: {
			required: true,
		},
		reason: {
			required: true,
		},
	},
	components: {
		SpecimenPlate,
	},
	data: () => ({
		reasons: [],
		modalAddVideoBySpecimen: false,
		search: "",
		isLoading: false,
		fields: [
			{ key: "specimen", label: "Ejemplar", class: "text-center" },
			{ key: "type", label: "TIPO", class: "text-center" },
			{ key: "date", label: "FECHA", class: "text-center" },
		],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		rows: [],
	}),
	computed: {},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await DeadsService.getDeadSpecimenDetails({
					start_date: this.year.start_date,
					end_date: this.year.end_date,
					gender: this.gender,
					reason_id: this.reason.id,
				})
				this.rows = data
			} catch (error) {
				console.error("Error fetching dead specimen details:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["specimen-dead-details-modal"].toggle()
		this.getRows()
	},
}
</script>

<style scoped>
.glove-blue {
	color: #007bff !important;
}
</style>
